import { render, staticRenderFns } from "./GameResultsChart.vue?vue&type=template&id=6838d104&"
import script from "./GameResultsChart.vue?vue&type=script&lang=js&"
export * from "./GameResultsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports